/**
 * Breadcrumb component will be used to display breadcrumbs on the page
 */

import globals from '../globals';

export default {
  name: 'vx-breadcrumb',
  components: {},
  props: {
    // breadcrumb details coming from parent component
    breadcrumbs: {
      type: Array,
    },
  },
  data() {
    return {
      globals,
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/common/vx-breadcrumb/vx-breadcrumb.js